import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_icon = _resolveComponent("l-icon")!
  const _component_l_marker = _resolveComponent("l-marker")!

  return (_openBlock(), _createBlock(_component_l_marker, _mergeProps(_ctx.$attrs, {
    options: { ..._ctx.options, interactive: _ctx.interactive }
  }), {
    default: _withCtx(() => [
      _createVNode(_component_l_icon, {
        "class-name": _ctx.className,
        "icon-url": _ctx.getIcon,
        "shadow-url": _ctx.markerShadow,
        "icon-size": _ctx.iconSize,
        "icon-anchor": _ctx.iconAnchor,
        "popup-anchor": _ctx.popupAnchor,
        "shadow-size": _ctx.shadowSize
      }, null, 8, ["class-name", "icon-url", "shadow-url", "icon-size", "icon-anchor", "popup-anchor", "shadow-size"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["options"]))
}